import React, { useRef } from 'react';

let appleSwitchSeq = 0;

/**
 * Pill toggle — adapted from Uiverse guilhermeyohan/great-snake-42 (MIT).
 * Structure: native checkbox + visual label (::after knob) for checked styling.
 */
export default function AppleSwitchCheckbox({
    id: idProp,
    className = '',
    inputClassName = '',
    checked,
    disabled = false,
    onChange,
    onClick,
    'aria-label': ariaLabel,
}) {
    const fallbackIdRef = useRef(null);
    if (!fallbackIdRef.current) {
        appleSwitchSeq += 1;
        fallbackIdRef.current = `apple-switch-${appleSwitchSeq}`;
    }
    const id = idProp || fallbackIdRef.current;

    return (
        <div className={`checkbox-apple ${className}`.trim()}>
            <input
                id={id}
                className={`checkbox-apple-native ${inputClassName}`.trim()}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                aria-label={ariaLabel}
                onChange={onChange}
                onClick={onClick}
            />
            <label htmlFor={id} className="checkbox-apple-ui" aria-hidden="true" />
        </div>
    );
}
